// candidate experience
import candidateExperience from '../pages/core/candidateExperience';
// cost per hire
import costPerHireDelegated from '../pages/core/costPerHireDelegated';
import costPerHireScs from '../pages/core/costPerHireScs';
// cover sheet
import coverSheet from '../pages/core/coverSheet';
// diversity and characteristics
import diversityAndCharacteristics from '../pages/core/diversityAndCharacteristics';
// time to fill
import timeToFill from '../pages/core/timeToFill';
// time to hire
import timeToHire from '../pages/core/timeToHire';
// vacancy holder experience
import vacancyHolderExperience from '../pages/core/vacancyHolderExperience';

import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: true,
  id: 'core',
  formName: 'Recruitment Metrics',
  title: 'CS Recruitment Measures and Benchmarks return',
  subTitle: 'Summary page',
  identifier: '{department}',
  register: true,
  showSections: true,
  strictDeadline: false,
  confirmationEmail: true,
  approvalAllowUnsubmit: true,
  allowUnlock: 30,
  sections: [
    {
      title: 'Department Information',
      slug: 'cover-sheet',
      subsections: [
        {
          title: 'Cover Sheet',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },
    {
      title: 'Time Metrics',
      slug: 'time-metrics',
      subsections: [
        {
          title: 'Time to Hire',
          slug: 'time-to-hire',
          pages: timeToHire,
        },
        {
          title: 'Time to Fill',
          slug: 'time-to-fill',
          pages: timeToFill,
        },
      ],
    },
    {
      title: 'Cost per Hire',
      slug: 'cost-per-hire',
      subsections: [
        {
          title: 'Delegated Recruitment',
          slug: 'cost-per-hire-delegated',
          pages: costPerHireDelegated,
        },
        {
          title: 'SCS Recruitment',
          slug: 'cost-per-hire-scs',
          pages: costPerHireScs,
        },
      ],
    },
    {
      title: 'Recruitment Experience',
      slug: 'nps',
      subsections: [
        {
          title: 'Candidate Experience',
          slug: 'candidate-experience',
          pages: candidateExperience,
        },
        {
          title: 'Vacancy Holder Experience',
          slug: 'vacholder-experience',
          pages: vacancyHolderExperience,
        },
      ],
    },
    {
      title: 'Diversity and Characteristics',
      slug: 'diversity-and-characteristics',
      subsections: [
        {
          title: 'Diversity and Characteristics',
          slug: 'diversity-and-characteristics',
          pages: diversityAndCharacteristics,
        },
      ],
    },
  ],
};
export default formConfig;
